import { isRejectedWithValue, Middleware, MiddlewareAPI } from '@reduxjs/toolkit'
import { showAlert } from './reducers/AppSlice'
import { handleCommonResponse } from '../../shared/lib/helpers/ErrorHandlingHelplers'
import { ICommonResponse } from '../../shared/types/CommonResponse.interface'

interface IRejectedPayload {
  status: number
  data: { message: string }
}

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const {
      status,
      data: { message },
    } = action.payload as IRejectedPayload

    if (status !== 403) {
      api.dispatch(
        showAlert({
          message,
          type: 'error',
        }),
      )
    }
  } else {
    const payload = (action as { payload?: unknown } | undefined)?.payload

    if (
      typeof payload === 'object' &&
      payload !== null &&
      'success' in payload &&
      !payload.success
    ) {
      handleCommonResponse(payload as ICommonResponse<unknown>, api.dispatch)
    }
  }

  return next(action)
}
